import { createSlice } from "@reduxjs/toolkit"


const initialState = {
    currentCompanyName:{},
    refershcompany:true,
    companyNames:[],
    totalPages:0,
    total:0,
    page:0,
    size:0
}

const companySlice = createSlice({
    name:'companyDropDown',
    initialState,
    reducers:{
        setSelectedCompany(state,action){
            state.currentCompanyName=action?.payload
        },
        setRefreshcompany(state,action){
            state.refershcompany=action?.payload
        },
        setcompany(state,action){
            state.companyNames= action?.payload?.pagination?[...state.companyNames,...action?.payload?.companyNames]:
            action?.payload?.companyNames
            state.page=action?.payload?.page
            state.size=action?.payload?.size
            state.totalPages=action?.payload?.totalPages
        },
        clearcompany(state, action) {
            return initialState
          }
    }
})

export const {setSelectedCompany,setRefreshcompany,setcompany,clearcompany}= companySlice.actions

export const companyActions = companySlice.actions

export default companySlice